import { Observable } from 'rxjs';

export abstract class ConsentDialogManager {
    abstract presentConsent(): Promise<void>;

    abstract hideConsent(): Promise<void>;

    abstract getConsent(): Observable<boolean>;
}
